'use client';

import { useModal } from '@cat-ecom/pcc-components';
import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { DealerLocatorLoaderProvider } from './dealer-locator-loader-context';

const DealerLocatorModalContext =
  createContext<ReturnType<typeof useModal>>(null);

export const useDealerLocatorModal = () =>
  useContext(DealerLocatorModalContext);

export const DealerLocatorModalProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const dealerLocatorModal = useModal({
    initialActive: false,
    size: 'md'
  });

  return (
    <DealerLocatorLoaderProvider>
      <DealerLocatorModalContext.Provider value={dealerLocatorModal}>
        {children}
      </DealerLocatorModalContext.Provider>
    </DealerLocatorLoaderProvider>
  );
};
